import React, { useEffect, useState } from 'react';
import { Button, Card, Nav, Tab, TabContent, TabPane } from 'react-bootstrap';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { CancellationBadge } from '@components/Numbers/Badges';
import {
  DidGroupTab,
  GeneralTab,
  OutboundRatesTab,
  ProfileTab,
  RoutingTab,
  ServicesTab,
  StatisticsTab,
} from '@components/Numbers/Details/Tabs';
import { Page404 } from '@containers/ErrorPages';
import { numberApi } from '@reducers/number/number';

export const Details = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { did } = useParams();
  const tabKey = state ? state.tabKey : 'general';
  const [key, setKey] = useState(tabKey);

  useEffect(() => setKey(tabKey), [tabKey]);
  const numberDetails = numberApi.useGetDetailsQuery({ did });
  if (numberDetails.isError && numberDetails.error.status === 404) {
    return <Page404 />;
  }
  return (
    <Tab.Container
      id="plan-details-tabs"
      activeKey={key}
      onSelect={(k) => setKey(k)}
      mountOnEnter
    >
      <Card className="mt-2">
        <Card.Text className="text-center bg-didxl text-white p-2 m-0">
          Number - <b>{did}</b>{' '}
          {numberDetails.data ? (
            <CancellationBadge
              isBeingCancelled={numberDetails.data.is_being_cancelled}
            />
          ) : null}
        </Card.Text>
        {numberDetails.isLoading ? <DefaultSpinnerCenter /> : null}
        {!numberDetails.isLoading && !numberDetails.isError ? (
          <>
            <Card.Header className="bg-didxl text-white">
              <Nav variant="tabs" fill>
                <Nav.Item>
                  <Nav.Link eventKey="general">General</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    eventKey="services"
                    disabled={numberDetails.isLoading}
                  >
                    Reachability/Services
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    eventKey="routing"
                    disabled={numberDetails.isLoading}
                  >
                    Routing
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    eventKey="outboundRates"
                    disabled={numberDetails.isLoading}
                  >
                    Outbound Rates
                  </Nav.Link>
                </Nav.Item>
                {numberDetails.data.is_capacity ? (
                  <Nav.Item>
                    <Nav.Link
                      eventKey="did-group"
                      disabled={numberDetails.isLoading}
                    >
                      DID Group
                    </Nav.Link>
                  </Nav.Item>
                ) : null}
                <Nav.Item>
                  <Nav.Link
                    eventKey="profile"
                    disabled={numberDetails.isLoading}
                  >
                    Profile
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    eventKey="statistics"
                    disabled={numberDetails.isLoading}
                  >
                    Statistics
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Card.Header>

            <Card.Body>
              <TabContent>
                <TabPane eventKey="general">
                  <GeneralTab did={did} />
                </TabPane>
                <TabPane eventKey="services">
                  <ServicesTab did={did} />
                </TabPane>
                <TabPane eventKey="routing">
                  <RoutingTab
                    did={did}
                    customerTrunk={numberDetails.data?.customer_trunk?.id}
                  />
                </TabPane>
                <TabPane eventKey="outboundRates">
                  <OutboundRatesTab did={did} />
                </TabPane>
                {numberDetails.data.is_capacity ? (
                  <TabPane eventKey="did-group">
                    <DidGroupTab did={did} />
                  </TabPane>
                ) : null}
                <TabPane eventKey="profile">
                  <ProfileTab
                    did={did}
                    profileID={numberDetails.data?.profile?.id}
                  />
                </TabPane>
                <TabPane eventKey="statistics">
                  <StatisticsTab did={did} />
                </TabPane>
              </TabContent>
            </Card.Body>
          </>
        ) : null}
      </Card>
      <Button
        className="mt-2"
        variant="didxl"
        size="sm"
        style={{ minWidth: '100px' }}
        onClick={() => navigate('/numbers/existing')}
      >
        Exit
      </Button>
    </Tab.Container>
  );
};
